export enum PlanMode {
  Edit = 'edit',
  Select = 'select'
}
